import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Space, Table, Menu, Image, message } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import baseRequest from "../../utils/baseRequest";
import VideoPlayer from "../../components/VideoPlayer";
const GuildMachineReviewContent = (props) => {
  const { TextArea } = Input;
  const current = props.current;
  //表头
  const columns = [
    {
      title: "提交帐号",
      dataIndex: "crater_info",
      key: "crater_info",
      render: (data) => (
        <div>
          <Image src={data?.avatar} width={50} />
          <p>
            ID：<span className="text-red-400">{data?.user_id}</span>
          </p>
          <p>
            昵称：<span className="text-red-400">{data?.name}</span>
          </p>
        </div>
      ),
    },
    {
      title: "公会信息",
      dataIndex: "info",
      key: "info",
      render: (data) => (
        <div className="flex flex-col ">
          <p>
            公会名称：<span className="text-red-400">{data.guild_name}</span>
          </p>
          <p>
            联系人：<span className="text-red-400">{data.contact_name}</span>
          </p>
          <p>
            联系方式：<span className="text-red-400">{data.contact_way}</span>
          </p>
          <p>
            达人数量：<span className="text-red-400">{data.streamer_num}</span>
          </p>
          <p>
            合作过的平台：
            <span className="text-red-400">{data.cooperated_platform}</span>
          </p>
        </div>
      ),
    },
    {
      title: "帐号截图",
      dataIndex: "account_shot",
      key: "account_shot",
      render: (data) => (
        <div className="flex flex-col">
          <div className="flex flex-wrap gap-1">
            {data?.images?.map((item, index) => (
              <Image key={index} src={item.urls[0]} width={100} />
            ))}
          </div>
          <p>{!data?.images?.length && "无截图"}</p>
        </div>
      ),
    },
    {
      title: "申请时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
      render: (_, record) => (
        <div className="flex flex-col">
          <Form.Item
            name={record.id}
            initialValue={record.remarks}
            // rules={[{ required: true, message: "请输入备注" }]}
          >
            <TextArea rows={4} disabled={current != "operatorReviewing"} />
          </Form.Item>
        </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            {current === "operatorReviewing" && (
              <Space.Compact direction="vertical">
                <Button type="primary" onClick={() => onClickPass(record)}>
                  已跟进
                </Button>
                <Button onClick={() => onClickReject(record)}>拒绝</Button>
              </Space.Compact>
            )}
            {current === "onlySelfCanSee" && (
              <p>{record.status === 1 ? "已跟进" : "已拒绝"}</p>
            )}
          </Space>
        </div>
      ),
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //点击通过按钮
  const onClickPass = (record) => {
    formRef.current.record = record;
    formRef.current.type = 0;
    formRef.current.submit();
  };
  //点击拒绝按钮
  const onClickReject = (record) => {
    formRef.current.record = record;
    formRef.current.type = 1;
    formRef.current.submit();
  };
  //提交表单
  const handleSubmit = async (value) => {
    if (value[formRef.current.record.id] == "") {
      // message.warning("备注不能为空");
      return;
    }
    try {
      //通过图片审核，如果是视频直接跳过
      const base = baseRequest();
      const response = await fetch("/op/guild_registration/approve", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ids: [parseInt(formRef.current.record.id, 10)],
          approve_status: formRef.current.type,
          remarks: value[formRef.current.record.id]
            ? value[formRef.current.record.id]
            : "",
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      //取消数据展示
      setShowData(
        showData.filter((item) => item.id !== formRef.current.record.id)
      );
    } catch (error) {
      console.error(error);
    }
  };
  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const getData = async () => {
    if (!more) return;
    let querryStatus;
    switch (current) {
      case "operatorReviewing":
        querryStatus = [0];
        break;
      case "onlySelfCanSee":
        querryStatus = [1, 2];
        break;
      default:
        break;
    }
    try {
      const base = baseRequest();
      const response = await fetch("/op/guild_registration/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          statuses: querryStatus,
          offset: offset,
          limit: 200,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      //匹配表格格式
      const structedData = temData.data.list.map((it) => ({
        ...it,
        crater_info: {
          avatar: it.account.avatar?.images[0].urls[0],
          user_id: it.account.user_id,
          name: it.account.name,
        },
        info: {
          contact_name: it.contact_name,
          contact_way: it.contact_way,
          cooperated_platform: it.cooperated_platform,
          guild_name: it.guild_name,
          streamer_num: it.streamer_num,
        },
        submitTime: new Date(it.ct * 1000).toLocaleString(),
      }));
      setData((old) => [...data, ...structedData]);
      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData();
  }, [current]);

  //展示的数据
  const [showData, setShowData] = useState([]);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <p>
        {current === "operatorReviewing" && `运营待审核${showData.length}条`}
        {current === "onlySelfCanSee" && `已处理${showData.length}条`}
      </p>
      <Form
        ref={formRef}
        name="remarks"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
    </div>
  );
};

export default function GuildMachineReview() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "operatorReviewing";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "待处理",
      key: "operatorReviewing",
    },
    // {
    //   label: "机审中",
    //   key: "machineReviewing",
    // },
    {
      label: "已处理",
      key: "onlySelfCanSee",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    window.location.reload();
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/guildMachineReview/operatorReviewing" />}
        />
        <Route
          path="/operatorReviewing"
          element={<GuildMachineReviewContent current="operatorReviewing" />}
        />
        <Route
          path="/onlySelfCanSee"
          element={<GuildMachineReviewContent current="onlySelfCanSee" />}
        />
      </Routes>
    </div>
  );
}
